import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initTimeline(): void {
  document.querySelectorAll('.timeline').forEach((timeline) => {
    const swiperHolder = timeline.querySelector('.swiper');
    if (swiperHolder) {
      const navNext = timeline.querySelector('.swiper-button-next');
      const navPrev = timeline.querySelector('.swiper-button-prev');

      // eslint-disable-next-line no-new
      new Swiper(swiperHolder as HTMLElement, {
        modules: [Navigation],
        centeredSlides: true,
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: navNext as HTMLElement | null,
          prevEl: navPrev as HTMLElement | null,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            centeredSlides: false,
          },
          992: {
            slidesPerView: 3,
            centeredSlides: true,
          },
        },
      });
    }
  });
}
